module.exports = __webpack_public_path__ + "img/letter_template.0adfc270.png";